import { TDeprecatedColors } from '@cian/ui-kit-design-tokens/colors/deprecated';
import { TColors } from '@cian/ui-kit-design-tokens/colors';

import * as styles from './styles.css';
import type { IMappedSocialLink } from 'shared/types/socials';
import { useDeviceType } from '@cian/ui-kit';
import clsx from 'clsx';

interface ISocialsProps {
  color?: TColors | TDeprecatedColors;
  bgColor?: string;
  items: ReadonlyArray<IMappedSocialLink>;
}

export const Socials: React.FC<ISocialsProps> = ({ items, bgColor = '#006cfd', color = 'white_100' }) => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['socials'], styles[device])}>
      {items.map(({ id, Icon, href }) => (
        <a
          style={{ backgroundColor: bgColor }}
          key={id}
          href={href}
          target="_blank"
          rel="noreferrer"
          className={styles['social-item']}
        >
          <Icon color={color} />
        </a>
      ))}
    </div>
  );
};
